import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Gauge, ChevronRight } from "lucide-react";

// Feature 24 — entry point into the free Meter & Serial Vault.
export function MeterSerialVaultCard({ propertyId }) {
  const navigate = useNavigate();
  return (
    <div className="rounded-2xl border border-[#E2E8F0] bg-white p-5 sm:p-6" data-testid="meter-serial-vault-card">
      <div className="flex items-center gap-2">
        <span className="grid place-items-center h-9 w-9 rounded-xl bg-brand/10 text-brand"><Gauge size={18} /></span>
        <h3 className="font-heading text-lg font-semibold text-navy">Meter &amp; Serial Vault</h3>
      </div>
      <p className="mt-2 text-sm text-[#475569]">
        Record utility meter readings over time and appliance make/model/serial numbers, with an optional photo for each. Private and free.
      </p>
      <Button data-testid="open-meter-serial-vault-btn" variant="outline" onClick={() => navigate(`/vault/${propertyId}`)}
        className="mt-4 h-11 px-5 rounded-xl border-[#E2E8F0] font-semibold">
        Open Vault <ChevronRight size={16} className="ml-1" />
      </Button>
    </div>
  );
}
